
import { put, takeEvery } from 'redux-saga/effects'
import * as actions from '../actions/actionTypes'
import pushToSentry from '../helpers/pushToSentry';

// get any filtered data except favorites 
// this will change for mobile
function* task(action) {
  try {
    // put GET_ALL_RECIPIES
    // yield call(filterTask.get)
    if (action.payload.selectedFilterName === 'search') {
      yield put({
        type: actions.GET_ALL_SEARCH_DATA_RECIPES,
        payload: {
          replace: true,
        }
      })
    } else {
      yield put({
        type: actions.GET_ALL_RECIPES,
        payload: {
          replace: true,
          isPaginatedData: true,
        }
      })
    }
  } catch (e) {
    const eventId = pushToSentry(e)
    yield put({
      type: actions.ADD_SENTRY_ERROR,
      payload: {
        error: e.message,
        eventId
      }
    })
    yield put({
      type: actions.FETCH_FILTERED_DATA_FAILURE,
      payload: {
        error: e.message
      }
    })
  }
}

export default function* fetchRecipesByCategory() {
  yield takeEvery(actions.APPLIED_SINGLE_FILTER, task)
}